import React, {useEffect, useState} from "react";
import {Container, Row, Col, Form} from "react-bootstrap";
import {
  Header,
  CenteredModal,
  InputCol,
  SelectCol,
  Buttons,
  SearchDropdown,
} from "components/common/modals";
import {countries} from "utils/constants";
import axios from "axiosConfig";
import ConfirmModal from "components/common/modals/ConfirmModal";
// import {SelectBroker} from "utils/constants";
// Mock data for select inputs
const mockSelectBroker = [
  "Interactive Brokers",
  "Zerodha",
  "Other Brokers",
  "Email Notifications",
];

function DcaModal({
                    show,
                    setShow,
                    isShowEditModal,
                    setDcaData,
                    dcaData,

                    ...props
                  }) {
  const {
    id,
    ticker,
    percent_down,
    order_max_quantity,
    total_max_quantity,
    max_amount,
    selectBroker,
    percent_account_to_invest,
    pe_ratio,
    on_off,
  } = dcaData;

  const [inputs, setInputs] = useState({
    country: "",
    ticker: ticker || "",
    percent_down: percent_down || "",
    order_max_quantity: order_max_quantity || "",
    total_max_quantity: total_max_quantity || "",
    max_amount: max_amount || "",
    selectBroker: selectBroker || "",
    percent_account_to_invest: percent_account_to_invest || "",
    pe_ratio: pe_ratio || "",
  });

  useEffect(() => {
    if (!show) {
      // Reset inputs only if it's not in edit mode
      if (!isShowEditModal) {
        setInputs({
          country: "",
          ticker: "",
          percent_down: "",
          order_max_quantity: "",
          total_max_quantity: "",
          max_amount: "",
          selectBroker: "",
          percent_account_to_invest: "",
          pe_ratio: "",
        });
      }
    }
  }, [show, isShowEditModal]);

  const [errors, setErrors] = useState({
    ticker: "",
    percent_down: "",
    order_max_quantity: "",
    total_max_quantity: "",
    max_amount: "",
  });
  const [isConfirmModal, setIsConfirmModal] = useState(false);

  // Data to be passed to the request payload
  const [postData, setPostData] = useState([]);

  // Handle input change
  const onSubmit = async (event) => {
    event.preventDefault();

    // Validate all inputs
    let newPostData;
    let isError = false;
    for (const [key, value] of Object.entries(inputs)) {
      const errorMsg = validate(key, value);
      setErrors((prev) => ({...prev, [key]: errorMsg}));

      if (errorMsg?.length > 0) isError = true;
      // if (value.length !== 0 ) newPostData = { ...newPostData, [key]: value };
    }

    // Check for errors

    if (isError) return;
    try {
      if (isShowEditModal) {
        setPostData({
          ...inputs,
          on_off,
        });
        setIsConfirmModal(true);
      } else {
        newPostData = {...inputs};
        const {data} = await axios.post("api/dcasetting/", {
          ...newPostData,
        });

        setDcaData((prev) => [...prev, data]);
        setShow(false);
      }
    } catch (error) {
      console.log("Dcasettings error: ", error);
    }
  };
  // Form submit

  // Confirm update data
  const handleConfirmUpdate = async () => {
    try {
      const {data} = await axios.patch(`api/dcasetting/${id}/`, {
        ...postData,
      });
      setDcaData((prev) => {
        const newDca = [...prev];
        const index = newDca.indexOf(dcaData);

        newDca.splice(index, 1, data);
        return newDca;
      });
      setShow(false);
      setIsConfirmModal(false);
    } catch (error) {
      console.log("Dcasettings error: ", error);
    }
  };

  // Handle input change

  const handleChange = (e) => {
    const {name, value, type} = e.target;
    let newValue = value;
    if (type === "number") newValue = parseFloat(value);

    // Use a callback to update each input change immediately
    setInputs((curInputs) => ({...curInputs, [name]: newValue}));
    validateInput(e);
  };

  // Validate single input

  const validateInput = (e) => {
    let {name, value} = e.target;
    const errorMsg = validate(name, value);
    setErrors((prev) => ({...prev, [name]: errorMsg}));
  };

  const validate = (name, value) => {
    let errorMsg;

    if (!isShowEditModal) {
      switch (name) {
        case "ticker":
          if (!value) errorMsg = "Please select Stock.";

          break;

        case "percent_down":
          if (!value) errorMsg = "Please enter value.";

          break;
        case "order_max_quantity":
          if (!value) errorMsg = "Please enter value.";

          break;
        case "total_max_quantity":
          if (!value) errorMsg = "Please enter value.";

          break;
        case "max_amount":
          if (!value) errorMsg = "Please enter value.";

          break;
        default:
          break;
      }
    }

    return errorMsg;
  };
  const content = (
    <Container>
      <Row>
        {/* Header */}
        {/* Different setup for Add (Has Header) and Edit (Has no header) broker */}
        {!isShowEditModal && (
          <Header
            title={"Smart DCA"}
            text={
              "Invest consistently based on price. " +
              "Automatically monitor and invest in " +
              "as many stocks as you want. " +
              "Invest " +
              "when the opportunity is right. Generate higher returns."
            }
          />
        )}

        {/* Main Form Inputs */}

        <Col sm={12} lg={8} className="mt-4 mt-lg-5 mx-auto">
          <Form noValidate onSubmit={onSubmit}>
            <Row>
              <Col sm={12} className="mb-4 text-center text-lg-start">
                {/* Different setup for Add and Edit broker */}
                <h3>
                  {isShowEditModal
                    ? "Edit your SMART DCA instruction"
                    : "Add your SMART DCA"}
                </h3>
              </Col>
              {/* Main inputs */}

              <SelectCol
                label="Country"
                name={"country"}
                value={inputs.country}
                handleChange={handleChange}
                options={countries}
              />
              <SearchDropdown
                country={inputs.country}
                label="Stock"
                name={"ticker"}
                placeholder={"Select Stock"}
                value={inputs.ticker}
                handleChange={handleChange}
                errorMsg={errors.ticker}
                validateInput={validateInput}
                isValidate={true}
              />
              {/* Additional Inputs */}
              <Col sm={12} className="mt-4 mb-4 d-flex justify-content-center">
                <Container>
                  <Row
                    style={{
                      padding: "20px",
                      border: "1px solid #4C4B56",
                      borderRadius: "8px",
                    }}
                  >
                    <Col sm={12} className="px-0">
                      <h5>Invest amount</h5>
                    </Col>
                    <InputCol
                      label="Percent Down"
                      name={"percent_down"}
                      value={inputs.percent_down}
                      errorMsg={errors.percent_down}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 pe-lg-2"
                      placeholder="0"
                      hint="Automated purchase when stock price goes down by this percentage"
                    />
                    <InputCol
                      label="Max Quantity per Order"
                      name={"order_max_quantity"}
                      type="text"
                      value={inputs.order_max_quantity}
                      errorMsg={errors.order_max_quantity}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 ps-lg-2"
                      placeholder="1"
                      hint="System will buy this number of stock when criteria is met"
                    />

                    <InputCol
                      label="Maximum Quantity"
                      name={"total_max_quantity"}
                      value={inputs.total_max_quantity}
                      errorMsg={errors.total_max_quantity}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 pe-lg-2"
                      placeholder="0"
                      hint="Total number of shares we want to buy of the selected stock"
                    />
                    <InputCol
                      label="Total Amount"
                      name={"max_amount"}
                      value={inputs.max_amount}
                      errorMsg={errors.max_amount}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 ps-lg-2"
                      placeholder="0"
                      hint="Total amount we want to buy of the selected stock"
                    />
                  </Row>
                </Container>
              </Col>

              {/* Footer Input */}
              <Col className="mb-3 mt-2" lg={12}>
                <SelectCol
                  label="Select Broker"
                  name={"selectBroker"}
                  value={inputs.selectBroker}
                  handleChange={handleChange}
                  colClass="px-0 mb-4 pe-lg-2"
                  options={mockSelectBroker}
                />
              </Col>
              {/* Buttons */}

              <Buttons
                setShow={setShow}
                isShowEditModal={isShowEditModal}
                addBtnText={"SMART"}
              />
            </Row>
          </Form>
        </Col>
      </Row>
      {/* Update confirmation modal */}
      <ConfirmModal
        show={isConfirmModal}
        handleClick={handleConfirmUpdate}
        setShow={setIsConfirmModal}
        header="Are you sure you want to Edit your DCA instruction?"
      />
    </Container>
  );

  return (
    <CenteredModal
      bodyContent={content}
      show={show}
      setShow={setShow}
      //  Different setup for Add and Edit broker
      size={isShowEditModal ? "lg" : "xl"}
    />
  );
}

export default DcaModal;
